<template>
  <!-- 1-摄制供应商   2-剧本供应商  3-成片供应商 -->
  <SuppliersList :type="3"></SuppliersList>
</template>

<script setup>
import SuppliersList from './components-suppliers/SuppliersList.vue'
</script>